// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
import { extractStyleCSSBlocks, normalizeCSSBlock, STYLE_TAG_REGEX } from './editor-css';

/**
 * Merge TipTap body HTML with a full-document prefix/suffix and de-duplicate
 * body `<style>` blocks already present in the head prefix.
 */
export const mergeBodyHTMLForSave = (
  bodyHTML: string,
  prefix: string | null,
  suffix: string | null
): string => {
  if (prefix == null || suffix == null) return bodyHTML;

  const headCSS = extractStyleCSSBlocks(prefix);
  let dedupedBody = bodyHTML;
  if (headCSS.size > 0) {
    dedupedBody = bodyHTML.replace(STYLE_TAG_REGEX, (match, inner) => {
      const normalized = normalizeCSSBlock(String(inner));
      return normalized && headCSS.has(normalized) ? '' : match;
    });
  }
  return prefix + dedupedBody + suffix;
};
